import Axios from "axios"
import QueryString from "qs"

import Config from "./Config"
import Log from "./Log"
import Util from "./Util"


export default class Request
{
    static Timeout = 90;

    static ErrorTooLong = 2;
    static ErrorResponse = 3;
    static ErrorLocal = 4;

    static ResponseTimes = {};

    static Running = [];
    static IsWatchingUnload = false;
    static RunningCount = 0;

    /**
     * [Constructor]
     *
     * @param {String} url
     * @param {Object} params
     * @returns {Request}
     */
    constructor(url, params) {
        this.url = url;
        this.params = params;
        this.httpHeaders = {
            // 'Content-Type': 'application/json',
            // 'Accept': 'application/json',
        };

        this.errorType,
            this.didHandleError = false,
            this.didFinish = false,
            this.wasCancelled = false;
    }


    /*
    |--------------------------------------------------------------------------
    | Headers
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @param {Object} headers
     * @returns {Request}
     */
    headers(headers) {
        for (let key in headers) {
            this.httpHeaders[key] = headers[key];
        }

        return this;
    }

    /**
     * [Note]
     *
     * @param key
     * @param {String} value
     * @returns {Boolean}
     */
    hasHeader(key, value) {
        return this.httpHeaders[key] === value;
    }


    /*
    |--------------------------------------------------------------------------
    | Configuration
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @param {Object} options
     * @returns {Object}
     */
    configure(options = {}) {
        let cancelToken = Axios.CancelToken;
        this.cancelTokenSource = cancelToken.source();

        let params = this.params ? { ...this.params } : {};

        // if (this.method.toLowerCase() === 'post') {
        //     let csrfTokenTag = document.querySelector(
        //         'meta[name="csrf-token"]'
        //     );
            // if (csrfTokenTag && csrfTokenTag.getAttribute('content')) {
            //     this.httpHeaders['X-Requested-With'] = 'XMLHttpRequest';
            //     this.httpHeaders['X-CSRF-TOKEN'] = csrfTokenTag.getAttribute('content');
                // params._token = csrfTokenTag.getAttribute('content');
                // this.params = {...params};
            // }
        // }


        let config = {
            url: this.urlWithParams(),
            method: this.method,
            headers: this.httpHeaders,
            timeout: Request.Timeout * 1000,
            cancelToken: this.cancelTokenSource.token,
            paramsSerializer: function (params) {
                return QueryString.stringify(params, {
                    arrayFormat: 'brackets'
                })
            }
        };

        for (let key in options) {
            config[key] = options[key];
        }

        if (this.hasHeader('Content-Type', 'multipart/form-data')) {
            const data = this.constructor.toFormData(params);
            config.data = data;
        }
        else if (this.method === 'GET' && !config.encodeAs) {
            config.encodeAs = 'QueryString';
        }
        else if (this.method !== 'GET' && !config.encodeAs) {
            config.encodeAs = 'JSON';
        }

        if (config.encodeAs === 'QueryString') {
            delete config.encodeAs;
            config.params = null;
            config.data = null;
            this.url = this.queryString();
            config.url = this.url;
        }
        else if (config.encodeAs === 'JSON') {
            config.data = { ...params };
        }

        return config;
    }

    /**
     * [Note]
     *
     * @param method
     * @param {Object} options
     * @returns {Promise}
     */
    build(method, options = {})
    {
        this.method = method;

        this.instance = Axios.create();

        this.interceptRequest().interceptResponse();

        let config = this.configure(options);

        this.constructor.RunningCount++;
        this.constructor.Running.push(this);

        if (this.method.toLowerCase() !== 'get') {
            this.constructor.refreshWindowUnload();
        }

        return this.instance.request(
            config
        );
    }

    /**
     * [Note]
     *
     * @param {Request}
     * @returns {Promise}
     */
    static async grouped(...requests) {
        return new Promise((resolve, reject) => {
            Axios.all(requests).then(
                Axios.spread((...responses) => {
                    resolve(responses);
                })
            ).catch(error => reject(error));
        });
    }

    /**
     * [Note]
     *
     * @returns {Request}
     */
    interceptRequest() {
        this.instance.interceptors.request.use(config => {
            this.log();

            config.metadata = {
                started_at: new Date()
            };

            // Do something before request is sent
            return config;
        }, error => {
            // console.log(error);
            this.log();
            // Do something with request error
            return Promise.reject(error);
        });

        return this;
    }

    /**
     * [Note]
     *
     * @returns {Request}
     */
    interceptResponse() {
        this.instance.interceptors.response.use(response => {
            response.raw = response.data;
            response.data = response.raw;

            response.config.metadata.ended_at = new Date();
            response.duration = response.config.metadata.ended_at - response.config.metadata.started_at;

            this.response = response;
            this.didFinish = true;

            this.constructor.RunningCount--;
            this.constructor.Running = TB.filter(this.constructor.Running,request => !request.didFinish);

            this.constructor.refreshWindowUnload();

            this.log();

            return response.data;
        }, async(error) => {

            if (Axios.isCancel(error)) {
                this.wasCancelled = true;
            }
            else if (error.response) {

                try {

                    error.config.metadata.ended_at = new Date();
                    error.duration = error.config.metadata.ended_at - error.config.metadata.started_at;

                }catch {}
                // The request was made and the server
                // responded with a status code that
                // falls out of the range of 2xx

                // handle 401
                let status = error.response.status;
                // console.log(status);
                if (TB.auth().loaded() && status == 401) {
                    TB.auth().expire();
                }

                error.response = { ...error.response };
                this.error = error;
                error.response.raw = error.response.data;
                error.response.data = error.response.raw;

                let data = error.response.data;

                this.response = { ...error.response, ...data };

                this.errorType = Request.ErrorResponse;

                this.error = { ...error, response: { ...this.response } };
            }
            else if (error.request) {

                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest
                // in the browser and an instance of
                // http.ClientRequest in node.js

                this.error = error;
                this.errorType = Request.ErrorTooLong;
            }
            else {

                // Something happened in setting up the request
                // that triggered an Error

                this.error = error;
                this.errorType = Request.ErrorLocal;
            }

            if (!this.error && this.errorType) {
                this.error = this.errorType;
            }

            this.didFail = true;
            this.didFinish = !this.wasCancelled;

            this.constructor.RunningCount--;
            this.constructor.Running = TB.filter(this.constructor.Running,request => !request.didFinish);

            this.constructor.refreshWindowUnload();

            this.log();
            this.reportServerError();

            return Promise.reject(error);
        });

        return this;
    }


    /*
    |--------------------------------------------------------------------------
    | Start/Stop
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @param {Object} options
     * @returns {Promise}
     */
    get(options) {
        return this.run('GET', options);
    }

    /**
     * [Note]
     *
     * @param {Object} options
     * @returns {Promise}
     */
    post(options) {
        return this.run('POST', options);
    }

    /**
     * [Note]
     *
     * @param {Object} options
     * @returns {Promise}
     */
    patch(options) {
        return this.run('PATCH', options);
    }

    /**
     * [Note]
     *
     * @param {Object} options
     * @returns {Promise}
     */
    delete(options) {
        return this.run('DELETE', options);
    }

    /**
     * [Note]
     *
     * @returns {Bool}
     */
    isRunning() {
        return this.method !== undefined
            && !this.didFinish
            && !this.wasCancelled;
    }

    /**
     * [Note]
     *
     * @param {String} method
     * @param {Object} options
     * @returns {Promise}
     */
    run(method, options) {
        return this.build(
            method, options
        );
    }

    /**
     * [Note]
     *
     * @returns {Request}
     */
    cancel() {
        if (this.didFail || this.didFinish) {
            return this;
        }

        this.wasCancelled = true;
        this.cancelTokenSource.cancel(
            'Operation canceled by the user.'
        );
        if (this.IsWatchingUnload) {
            this.ignoreWindowUnload();
        }

        return this;
    }


    /*
    |--------------------------------------------------------------------------
    | Window Unload Warnings
    |--------------------------------------------------------------------------
    */



    static refreshWindowUnload()
    {
        // console.log('Request @ refreshWindowUnload => this.RunningCount', this.RunningCount);

        if (this.RunningCount <= 0
            && this.IsWatchingUnload)
        {
            return this.ignoreWindowUnload();
        }
        else if (this.RunningCount > 0
            && !this.IsWatchingUnload)
        {
            return this.watchForWindowUnload();
        }
    }

    static handleWindowUnload(event)
    {
        // console.log('Request @ handleWindowUnload');

        let message = 'Are you sure?';

        if (typeof event == 'undefined') {
            event = window.event;
        }

        if (event) {
            event.returnValue = message;
        }

        return message;
    }

    static watchForWindowUnload()
    {
        this.IsWatchingUnload = true;

        window.addEventListener(
            "beforeunload", this.handleWindowUnload
        );

        // console.log('Request @ watchForWindowUnload');
    }


    static ignoreWindowUnload()
    {
        window.removeEventListener(
            "beforeunload", this.handleWindowUnload
        );

        this.IsWatchingUnload = false;

        // console.log('Request @ ignoreWindowUnload');
    }


    /*
    |--------------------------------------------------------------------------
    | Error Handling
    |--------------------------------------------------------------------------
    */

    errorMessage()
    {
        if (!Util.isObject(this.response)) {
            return 'network_error';
        }

        if (!Util.isObject(this.response.data)
            || !Util.isObject(this.response.data.error)
            || !Util.isString(this.response.data.error.message)) {
            return;
        }

        return this.response.data.error.message;
    }


    handleError(fireAlert = true)
    {
        return new Promise((resolve,reject) => {
            let errorMessage = this.errorMessage();
            console.log('Request.handleError', errorMessage)
            if (!errorMessage) {
                return resolve(false);
            }

            if (errorMessage === 'unauthenticated') {
                console.log('Request.handleError -> unauthenticated', errorMessage)
                if (TB.auth().exists()) {
                    TB.auth().expire();
                }

                return resolve(true);
            }

            if (this.method.toLowerCase() !== 'post') {
                console.log('Request.handleError -> this.method', this.method, errorMessage)
                return resolve(false);
            }

            if (errorMessage === 'invalid_input_format') {
                console.log('Request.handleError -> invalid_input_format', errorMessage)
                return resolve(false);
            }


            let errorKey = errorMessage ? errorMessage : 'server_error';
            console.log('Request.handleError -> errorKey', errorKey)
            let title, message, actions;


            switch (errorKey)
            {
                case 'invalid_input_format':
                    return resolve(false);                    // title = Util.trans('api.invalid_input_format.title');

                    // message = `<p>${Util.trans('api.invalid_input_format.message')}</p>`;
                    //
                    // try {
                    //     let data = TB.tryObject(this.response.data?.error?.data);
                    //
                    //     let reasons = '';
                    //     for (let messages of Object.values(data)) {
                    //         TB.tryArray(messages).map(reason => {
                    //             reasons += `<li>${reason}</li>`
                    //         });
                    //     }
                    //
                    //     if (Object.keys(data).length) {
                    //         message += `<ul>${reasons}</ul>`
                    //     }
                    // }catch {
                    //     console.warn('WARN: ','Could no parse input validations')
                    // }
                    //
                    // actions = [
                    //     {
                    //         title: 'Try Again',
                    //         click: async() => {
                    //             this.shouldRerun = true;
                    //             resolve(true);
                    //         }
                    //     },
                    //     {
                    //         title:'Okay',
                    //         click: () => {
                    //             resolve(true);
                    //         }
                    //     }
                    // ]
                    break;

                case 'sso_required':
                    let ssoProvider = this.response.data?.error?.data?.sso_provider;

                    title = "SSO Required"
                    message = `Login via password is not allowed for your account.  You can only login via ${ssoProvider}`
                    actions = [
                        {
                            title: 'Okay',
                            click: () => {
                                resolve(true);
                            }
                        },
                    ];
                    console.log('Request.handleError -> sso_provider', title, message, actions)
                    break;

                case 'method_not_allowed':
                case 'system_maintenance':
                case 'not_found':
                case 'bad_credentials':
                    try {
                        if (!Util.trans(`api.${errorKey}`)) {
                            errorKey = 'server_error';
                        }
                    }
                    catch (e) {
                        errorKey = 'server_error';
                    }

                    title = Util.trans(`api.${errorKey}.title`);
                    message = Util.trans(`api.${errorKey}.message`);
                    actions = [
                        {
                            title: 'Okay',
                            click: () => {
                                resolve(true);
                            }
                        },
                    ];
                    break;

                case 'too_many_bad_attempts':
                    title = Util.trans(`api.${errorKey}.title`);
                    message = Util.trans(`api.${errorKey}.message`, {
                        seconds: Util.durationForHumans(
                            this.response.data.error.data.seconds
                        ),
                    })
                    actions = [
                        {
                            title: 'Okay',
                            click: () => {
                                resolve(true);
                            }
                        },
                    ];
                    break;

                case 'server_error':
                default:
                    title = Util.trans('api.server_error.title');
                    message = Util.trans('api.server_error.message', { code: this.response?.status || 500 });
                    actions = [
                        {
                            title: 'Try Again',
                            click: async() => {
                                this.shouldRerun = true;
                                resolve(true);
                            }
                        },
                        {
                            title:'Okay',
                            click: () => {
                                resolve(true);
                            }
                        }
                    ]
                    break;
            }

            console.log('REQUEST ERROR',{errorKey, title, message, actions})
            if (title && message) {
                console.log('Request.handleError -> fireAlert', title, message, actions, fireAlert)
                if(fireAlert) {
                    TB.alert(
                        'error',
                        title,
                        message,
                        actions
                    );
                    return resolve(true)
                }else {
                    resolve({title, message})
                }


            }

            return resolve(false);
        });
    }

    /*
    |--------------------------------------------------------------------------
    | Error Reporting
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @returns void
     */
    reportServerError() {
        if (this.errorType !== Request.ErrorResponse) {
            return;
        }

        let errorMessage = this.errorMessage();

        return this.report(
            errorMessage ? errorMessage : "No error message provided."
        );
    }

    statusCode()
    {
        return this.response
            ? this.response.status
            : "0";
    }

    /**
     * [Note]
     *
     * @param {String} errorMessage
     * @returns void
     */
    report(errorMessage) {
        let error = new Error(errorMessage),
            metadata = {
                http_request: this.loggableRequest(),
                http_response: {
                    statusCode: this.response
                        ? this.response.status
                        : "Unknown",
                    data: this.response
                        ? this.response.data
                        : null,
                },
            };
        // Bugsnag.report(error, metadata);
    }



    /*
    |--------------------------------------------------------------------------
    | Mutating Params
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @param {Object} params
     * @param {String} prefix
     * @param {FormData} formData
     * @returns {FormData}
     */
    static toFormData(params, prefix, formData)
    {
        if (!formData) {
            formData = new FormData();
        }

        for (let key in params) {
            let fieldKey = key;
            if (prefix) {
                fieldKey = prefix + '[' + key + ']';
            }

            let value = params[key];
            if (!TB.isDefined(value)) {
                value = '';
            }
            else if (TB.isBoolean(value)) {
                value = value ? '1' : '0'
            }

            if (value instanceof Date) {
                formData.append(fieldKey, value.toISOString());
            }
            else if (!(value instanceof File) &&
                !(value instanceof Function) &&
                !(value instanceof Blob) &&
                (Util.isObject(value) || Util.isArray(value)))
            {
                formData = this.toFormData(value, fieldKey, formData);
            }
            else {
                formData.append(fieldKey, value);
            }
        }

        return formData;
    }


    /**
     * [Note]
     *
     * @returns {String}
     */
    queryString() {
        let params = this.params ? this.params : {};

        let url = this.urlWithParams() + '?' + QueryString.stringify(
            { ...params }
        );

        while (url.endsWith('?')) {
            url = url.substring(0, url.length - 1)
        }

        return url;
    }

    /**
     * [Note]
     *
     * @returns {String}
     */
    urlWithParams() {
        let params = this.params ? this.params : {};

        let evaluatedUrl = this.url;
        for (let key in params) {
            if (!evaluatedUrl.includes(`{${key}}`)) {
                continue;
            }

            evaluatedUrl = evaluatedUrl.replace(`{${key}}`, params[key]);
        }

        return evaluatedUrl;
    }

    /*
    |--------------------------------------------------------------------------
    | Logging Data
    |--------------------------------------------------------------------------
    */

    /**
     * [Note]
     *
     * @returns {Object}
     */
    loggableRequest() {
        return {
            url: this.url,
            headers: this.httpHeaders,
            method: this.method,
            params: this.params,
        };
    }

    /**
     * [Note]
     *
     * @returns void
     */
    logRequest() {
        if (this.didFinish
            || !Config.get('log.http.responses')) {
            return;
        }

        Log.object(
            'Request', this.loggableRequest()
        );
    }

    /**
     * [Note]
     *
     * @returns void
     */
    logResponse() {
        if (!this.didFinish
            || !Config.get('log.http.responses')) {
            return;
        }

        Log.object('Response', {
            request: this.loggableRequest(),
            status: this.response
                ? this.response.status
                : undefined,
            duration: this.response
                ? this.response.duration
                : undefined,
            error: this.error,
            data: this.response
                ? this.response.data
                : undefined,
        });
    }

    /**
     * [Note]
     *
     * @returns void
     */
    logResponseTimes() {
        if (!this.didFinish
            || !Config.get('log.http.response_times')) {
            return;
        }

        if (this.response
            && this.response.duration) {
            Request.ResponseTimes[
                this.method + ' ' + this.url
            ] = this.response.duration;
        }

        let total = 0, count = 0;
        for (let requestKey in Request.ResponseTimes) {
            total += Request.ResponseTimes[requestKey];
            count++;
        }
        let avg = total / count;

        Log.object(
            `Average Response Time: ${avg}`,
            Request.ResponseTimes
        );
    }

    /**
     * [Note]
     *
     * @returns {Request}
     */
    log() {
        this.logRequest();

        this.logResponse();

        this.logResponseTimes();

        return this;
    }

    /**
     * [Constructor]
     *
     * @param {String} url
     * @param params
     * @returns {Request}
     */
    static make(url, params) {
        return new Request(url, params);
    }
}